"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderVariantsOneToSeven = exports.renderVariantEightToTen = exports.imageSizes = exports.ctaRowOrColumn = exports.checkForVariant = void 0;
var _react = _interopRequireWildcard(require("react"));
var _fpoSquare = _interopRequireDefault(require("../../images/fpo-square.png"));
var _formatSpecialCharText = _interopRequireDefault(require("../../utils/formatSpecialCharText"));
var _generateFocusedImageAlt = _interopRequireDefault(require("../../utils/generateFocusedImageAlt"));
var _renderImageOrLottieAnimation = require("../../utils/renderImageOrLottieAnimation");
var _Video = _interopRequireDefault(require("../Video/Video"));
var _DataPoint = _interopRequireDefault(require("../DataPoint/DataPoint"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _CTASection = _interopRequireDefault(require("../CTASection/CTASection"));
var _Image = _interopRequireDefault(require("../Image/Image"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ctaRowOrColumn = (ctas, variant) => {
  const rowVariants = ["variant_3", "variant_6"];
  if (!ctas) {
    return;
  }
  if (ctas?.ctaOne?.video || ctas?.ctaTwo?.video) {
    ctas["VideoComponent"] = _Video.default;
  }
  const findRowVariant = () => {
    return rowVariants.find(type => {
      return type === variant;
    });
  };
  const hasLongText = () => {
    let longText = false;
    const ctaOneLength = ctas?.ctaOne?.text?.length;
    const ctaTwoLength = ctas?.ctaTwo?.text?.length;
    if (ctaOneLength >= 12 || ctaTwoLength >= 12) {
      longText = true;
    }
    return longText;
  };
  const getWindowDimensions = () => {
    let width = 0;
    let height = 0;
    if (typeof window !== "undefined") {
      const {
        innerWidth,
        innerHeight
      } = window;
      width = innerWidth;
      height = innerHeight;
    }
    return {
      width,
      height
    };
  };
  if (variant && variant === findRowVariant() && !hasLongText() && getWindowDimensions().width > 600) {
    ctas.direction = "row";
  } else {
    ctas.direction = "column";
  }
  return ctas;
};
exports.ctaRowOrColumn = ctaRowOrColumn;
const imageSizes = {
  variant_1: {
    desktop: {
      width: 720,
      height: 405,
      ratio: {
        width: 16,
        height: 9
      }
    },
    tablet: {
      width: 864,
      height: 480,
      ratio: {
        width: 9,
        height: 5
      }
    },
    mobile: {
      width: 640,
      height: 392,
      ratio: {
        width: 80,
        height: 49
      }
    }
  },
  variant_2: {
    desktop: {
      width: 560,
      height: 560,
      ratio: {
        width: 1,
        height: 1
      }
    },
    tablet: {
      width: 800,
      height: 800,
      ratio: {
        width: 1,
        height: 1
      }
    },
    mobile: {
      width: 600,
      height: 600,
      ratio: {
        width: 1,
        height: 1
      }
    }
  },
  variant_3: {
    desktop: {
      width: 720,
      height: 304,
      ratio: {
        width: 45,
        height: 19
      }
    },
    tablet: {
      width: 720,
      height: 400,
      ratio: {
        width: 9,
        height: 5
      }
    },
    mobile: {
      width: 320,
      height: 196,
      ratio: {
        width: 80,
        height: 49
      }
    }
  },
  variant_4: {
    desktop: {
      width: 480,
      height: 480,
      ratio: {
        width: 1,
        height: 1
      }
    },
    tablet: {
      width: 720,
      height: 720,
      ratio: {
        width: 1,
        height: 1
      }
    },
    mobile: {
      width: 320,
      height: 320,
      ratio: {
        width: 1,
        height: 1
      }
    }
  },
  variant_5: {
    desktop: {
      width: 1440,
      height: 700,
      ratio: {
        width: 72,
        height: 35
      }
    },
    tablet: {
      width: 960,
      height: 480,
      ratio: {
        width: 2,
        height: 1
      }
    },
    mobile: {
      width: 320,
      height: 196,
      ratio: {
        width: 80,
        height: 49
      }
    }
  },
  variant_6: {
    desktop: {
      width: 1120,
      height: 490,
      ratio: {
        width: 16,
        height: 7
      }
    },
    tablet: {
      width: 720,
      height: 420,
      ratio: {
        width: 12,
        height: 7
      }
    },
    mobile: {
      width: 640,
      height: 245,
      ratio: {
        width: 80,
        height: 49
      }
    }
  },
  variant_7: {
    desktop: {
      width: 800,
      height: 450,
      ratio: {
        width: 16,
        height: 9
      }
    },
    tablet: {
      width: 720,
      height: 420,
      ratio: {
        width: 12,
        height: 7
      }
    },
    mobile: {
      width: 320,
      height: 196,
      ratio: {
        width: 80,
        height: 49
      }
    }
  },
  variant_8: {
    desktop: {
      width: 950,
      height: 950,
      ratio: {
        width: 1,
        height: 1
      }
    },
    tablet: {
      width: 950,
      height: 950,
      ratio: {
        width: 1,
        height: 1
      }
    },
    mobile: {
      width: 640,
      height: 640,
      ratio: {
        width: 1,
        height: 1
      }
    }
  },
  variant_9: {
    desktop: {
      width: 720,
      height: 480,
      ratio: {
        width: 3,
        height: 2
      }
    },
    tablet: {
      width: 960,
      height: 480,
      ratio: {
        width: 2,
        height: 1
      }
    },
    mobile: {
      width: 360,
      height: 220,
      ratio: {
        width: 3,
        height: 2
      }
    }
  },
  variant_10: {
    desktop: {
      width: 960,
      height: 650,
      ratio: {
        width: 27,
        height: 19
      }
    },
    tablet: {
      width: 960,
      height: 480,
      ratio: {
        width: 2,
        height: 1
      }
    },
    mobile: {
      width: 360,
      height: 220,
      ratio: {
        width: 3,
        height: 2
      }
    }
  }
};
exports.imageSizes = imageSizes;
const generateAnimationRatio = (imageSize, currentScreenSize) => {
  if (!imageSize || !currentScreenSize) {
    return null;
  }
  return imageSize[currentScreenSize]?.ratio;
};
const determineCurrentBreakpoint = () => {
  const breakPoints = {
    large: 1800,
    medium: 960,
    small: 640
  };
  // reads element wrapper width + sets breakpoint state object
  if (window?.width <= breakPoints.small) {
    return "mobile";
  } else if (window?.width <= breakPoints.medium) {
    return "tablet";
  } else {
    return "desktop";
  }
};
const renderImage = (image, focusedImage, variant, superHeroAnimation, lazyLoad) => {
  if (superHeroAnimation && superHeroAnimation?.src) {
    return (0, _renderImageOrLottieAnimation.renderImageOrLottieAnimation)(superHeroAnimation, null, null, null, "ter-super-hero__lottie", null, true, generateAnimationRatio(imageSizes[variant], determineCurrentBreakpoint()));
  } else if (!image && focusedImage) {
    return (0, _renderImageOrLottieAnimation.renderImageOrLottieAnimation)(focusedImage?.focalPointImage, null, imageSizes[variant], (0, _generateFocusedImageAlt.default)(focusedImage), "ter-super-hero__image", null, undefined, undefined, lazyLoad);
  } else if (image && !focusedImage) {
    return /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: image?.src ? image.src : _fpoSquare.default,
      alt: image?.alt || "placeholder image",
      className: "luna-super-hero__image",
      lazyLoad: lazyLoad,
      onError: e => {
        e.target.onerror = null;
        e.target.src = _fpoSquare.default;
      }
    });
  }
};
const checkForVariant = variant => {
  if (variant === "variant_8" || variant === "variant_9" || variant === "variant_10") {
    return "super-hero--fullscreen-components";
  } else {
    return "super-hero--padded-components";
  }
};
exports.checkForVariant = checkForVariant;
const renderVariantsOneToSeven = (contentfulIdSuperHero, contentfulId, variant, contentSide, focusedImage, imageSizes, eyebrow, header, isLongSubheader, subHeader, text, cta, ctas, theme, Link, mouse, color, backgroundColor, paddingClass, modalDeployed, image, video, thumbnail, hovering, playing, deployModal, hideModal, setHovering, togglePlaying, content, ContentComponent, transcriptVisable, setTranscriptVisable, transcript, transcriptText, closeTranscript, alignTop, videoProgress, setVideoProgress, override, superHeroAnimation, lazyLoad, isPageHeader) => {
  const alignmentClass = alignTop ? "luna-super-hero__image-wrapper--uneven-alignment" : "";
  const type = checkForVariant(variant);
  if (type === "super-hero--padded-components") {
    return /*#__PURE__*/_react.default.createElement("section", {
      "data-sb-object-id": contentfulIdSuperHero,
      className: `luna-super-hero luna-super-hero-${variant}-${contentSide} ${paddingClass} ${lazyLoad == false ? ' luna-super-hero--no-transition' : ''}`,
      style: {
        background: backgroundColor,
        color: color
      }
    }, /*#__PURE__*/_react.default.createElement("aside", {
      className: `luna-super-hero__image-wrapper luna-super-hero__image-wrapper-${variant}-${contentSide} ${alignmentClass}`,
      "data-sb-field-path": "media"
    }, /*#__PURE__*/_react.default.createElement("span", {
      tabIndex: mouse ? "" : "0"
    }, renderImage(image, focusedImage, variant, superHeroAnimation, lazyLoad)), video && /*#__PURE__*/_react.default.createElement(_Video.default, {
      content: content,
      override: override
    })), !modalDeployed && /*#__PURE__*/_react.default.createElement("aside", {
      className: `luna-super-hero__content-wrapper luna-super-hero__content-wrapper-${variant}-${contentSide}`,
      "data-sb-field-path": "heroContent"
    }, ContentComponent ? /*#__PURE__*/_react.default.createElement(ContentComponent, null) : /*#__PURE__*/_react.default.createElement("div", {
      "data-sb-object-id": contentfulId
    }, eyebrow ? /*#__PURE__*/(0, _react.createElement)(isPageHeader ? 'h1' : 'h2', {
      className: 'luna-super-hero__eyebrow',
      style: {
        color: color
      },
      'data-sb-field-path': 'eyebrow'
    }, eyebrow) : null, header ? /*#__PURE__*/(0, _react.createElement)(eyebrow ? 'h3' : isPageHeader ? 'h1' : 'h3', {
      className: 'luna-super-hero__header',
      style: {
        color: theme?.headerColor ? theme?.headerColor : color
      },
      'data-sb-field-path': 'headline',
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header)
    }, null) : null, subHeader && /*#__PURE__*/_react.default.createElement("p", {
      "data-sb-field-path": isLongSubheader ? "longSubhead" : "subhead",
      className: "luna-super-hero__subHeader",
      style: !text ? {
        color: color,
        marginBottom: "37px"
      } : {
        color: color
      },
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(subHeader)
    }), text && /*#__PURE__*/_react.default.createElement("div", {
      "data-sb-field-path": "body",
      className: `luna-super-hero__text luna-super-hero__text-${color && color?.toLowerCase()}`,
      style: {
        color: color
      },
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(text)
    }), !ctas && cta && /*#__PURE__*/_react.default.createElement(_Button.default, {
      Link: Link,
      url: cta.url,
      text: cta.text,
      VideoComponent: _Video.default,
      video: cta?.video,
      override: override,
      setOverride: setOverride,
      className:
      // TODO this will change once we have themes and button styling/themes confirmed
      theme?.ctaOne ? `ter-button--${theme?.ctaOne}` : "ter-button--primary--1"
    }), ctas && /*#__PURE__*/_react.default.createElement(_CTASection.default, {
      ctas: ctaRowOrColumn(ctas, variant)
    }))));
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
};
exports.renderVariantsOneToSeven = renderVariantsOneToSeven;
const renderVariantEightToTen = (contentfulIdSuperHero, contentfulId, variant, ContentComponent, contentSide, focusedImage, imageSizes, eyebrow, header, isLongSubheader, subHeader, text, cta, ctas, theme, Link, mouse, color, backgroundColor, dataPoints, superHeroAnimation, lazyLoad, isPageHeader) => {
  const type = checkForVariant(variant);
  if (type === "super-hero--fullscreen-components") {
    const hasDataPoints = dataPoints && Array.isArray(dataPoints) && dataPoints?.length > 0;
    return /*#__PURE__*/_react.default.createElement("section", {
      "data-sb-object-id": contentfulIdSuperHero,
      className: `super-hero-fullscreen super-hero-fullscreen-${variant} ${hasDataPoints ? "super-hero-fullscreen--data-points" : ""} ${lazyLoad == false ? ' luna-super-hero--no-transition' : ''}`,
      style: {
        backgroundColor: theme?.backgroundColor || "#F8F8FB",
        color: color
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `super-hero-fullscreen__hero-image super-hero-fullscreen__hero-image-${variant}-${contentSide} super-hero-fullscreen--focused super-hero-fullscreen--focused-${variant}-${contentSide}`
    }, /*#__PURE__*/_react.default.createElement("span", {
      tabIndex: mouse ? "" : "0",
      className: "super-hero-fullscreen__hero-image-wrapper",
      "data-sb-field-path": "media"
    }, renderImage(null, focusedImage, variant, superHeroAnimation, lazyLoad))), hasDataPoints && /*#__PURE__*/_react.default.createElement("section", {
      className: `super-hero-fullscreen__data-points super-hero-fullscreen__data-points--${contentSide}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-sb-field-path": "dataPoints"
    }, /*#__PURE__*/_react.default.createElement(_DataPoint.default, {
      contentfulId: dataPoints?.contentfulId,
      points: dataPoints?.points,
      variant: "variant_2A",
      theme: {
        color: "#ffffff",
        backgroundColor: "#0063A3"
      }
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: `super-hero-fullscreen__container super-hero-fullscreen__container-${variant}-${contentSide}`
    }, /*#__PURE__*/_react.default.createElement("aside", {
      className: `super-hero-fullscreen__content-block super-hero-fullscreen__content-block-${variant}-${contentSide}`,
      "data-sb-field-path": "heroContent"
    }, ContentComponent ? /*#__PURE__*/_react.default.createElement(ContentComponent, null) : /*#__PURE__*/_react.default.createElement("div", {
      "data-sb-object-id": contentfulId
    }, eyebrow ? /*#__PURE__*/(0, _react.createElement)(isPageHeader ? 'h1' : 'h2', {
      className: 'super-hero-fullscreen__eyebrow',
      style: {
        color: color
      },
      'data-sb-field-path': 'eyebrow'
    }, eyebrow) : null, header ? /*#__PURE__*/(0, _react.createElement)(eyebrow ? 'h3' : isPageHeader ? 'h1' : 'h3', {
      className: 'super-hero-fullscreen__header',
      style: {
        color: theme?.headerColor ? theme?.headerColor : color
      },
      'data-sb-field-path': 'headline',
      dangerouslySetInnerHTML: (0, _formatSpecialCharText.default)(header)
    }, null) : null, subHeader && /*#__PURE__*/_react.default.createElement("p", {
      "data-sb-field-path": isLongSubheader ? "longSubhead" : "subhead",
      className: "super-hero-fullscreen__subHeader",
      style: !text ? {
        color: color,
        marginBottom: "37px"
      } : {
        color: color
      }
    }, subHeader), text && /*#__PURE__*/_react.default.createElement("div", {
      "data-sb-field-path": "body",
      className: `super-hero-fullscreen__text super-hero-fullscreen__text-${color && color?.toLowerCase()}`,
      style: {
        color: color
      },
      dangerouslySetInnerHTML: {
        __html: text
      }
    }), !ctas && cta && /*#__PURE__*/_react.default.createElement(_Button.default, {
      tabIndex: mouse ? "" : "0",
      Link: Link,
      url: cta.url,
      text: cta.text,
      className: theme?.ctaOne ? `ter-button--${theme?.ctaOne}` : "ter-button--primary--1"
    }), ctas && /*#__PURE__*/_react.default.createElement(_CTASection.default, {
      ctas: ctas
    })), hasDataPoints && /*#__PURE__*/_react.default.createElement("section", {
      className: `super-hero-fullscreen__data-points super-hero-fullscreen__data-points--mobile`
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-sb-field-path": "dataPoints"
    }, /*#__PURE__*/_react.default.createElement(_DataPoint.default, {
      contentfulId: dataPoints?.contentfulId,
      points: dataPoints?.points,
      variant: "variant_2A",
      theme: {
        color: "#ffffff",
        backgroundColor: "#0063A3"
      }
    }))))));
  } else {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
};
exports.renderVariantEightToTen = renderVariantEightToTen;